import { useQuery } from '@tanstack/react-query'
import { aiStudioService } from '../../service/aiStudio'
import { ImageAPIResponse } from '../../pages/ai-studio/gallery/types'

function useGetGalleryImages(page: number, limit: number, options?: { enabled?: boolean }) {
  return useQuery<ImageAPIResponse>({
    queryKey: ['gallery-images', page, limit],
    queryFn: async () => {
      const result = await aiStudioService.getMyImages(page, limit)
      return result
    },
    refetchInterval: (query) => {
      const data = query.state.data
      if (!data?.items) return false
      
      // 현재 페이지에 processing/pending 상태 이미지가 있는지 확인
      const hasProcessingImages = data.items.some(
        item => item.jobStatus === 'processing' || item.jobStatus === 'pending'
      )
      
      return hasProcessingImages ? 3000 : false // 3초마다 폴링 또는 중단
    },
    refetchIntervalInBackground: false,
    staleTime: 0, // 항상 최신 데이터 가져오기
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true, // 기본값은 true
  })
}

export default useGetGalleryImages